import { FetchCriteriaModel } from 'lib/ng2-sapmp/src/ui-components/custom-grid';

export class GridFetchModel {
  class: string;
  fetchCriteria: FetchCriteriaModel;
  withSubscriptions: Array<string>;
  searchValue: string;
  serviceOfferCodes: Array<string>;
  serviceStatus: string;
  licenseStatus: string;
  serviceClientId: string;
}
